import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";
import { Link, NavLink, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { Dash1, Dash2, Dash3, Dash4 } from "../../../common/imagePath";
import CountUp from "react-countup";
import moment from "moment";
import MaterialReactTable from "material-react-table";
import { checkUserPermission } from "../../../common/UserPermission";
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Sales = (props) => {
  let selectData = [];
  let PERMISSION_DELETE = "sales-batch-delete";
  let PERMISSION_EDIT = "/manage-sales/:id";
  let PERMISSION_ADD = "/manage-sales";
  let PERMISSION_RECEIVEPAYMENT = "/receive-payment";
  let PERMISSION_RECEIPT = "/sales-receipt/:id";
  let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
  let PERMISSION_DELIVERIES = "/deliveries";
  let PERMISSION_BATCHSALES = "/batch-sales";
  let PERMISSION_CUSTOMFIELD = "/custom-field-sales-configuration";
  let PERMISSION_ALLRECEIPT = "/sales-all-receipt";

  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [salesSummary, setSalesSummary] = useState([]);
  const [status, setStatus] = useState(0);

  const [filterTotalQuantity, setFilterTotalQuantity] = useState(0);
  const [filterTotalAmount, setFilterTotalAmount] = useState(0);

  const [totalItemAmount, setTotalItemAmount] = useState(0);
  const [totalItemQuantity, setTotalItemQuantity] = useState(0);

  console.log(filterTotalAmount, filterTotalQuantity, "filterTotalQuantity");

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [customerValue, setCustomerValue] = useState();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  console.log("QuickBookOptions::>>", quickBookOptions);
  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status
    );
  };

  const handleUnSuspend = (pID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/findbyid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = (
    // pagenumber,
    // pagesize,
    // filtertext,
    // ordercolumn,
    // currentorder,
    startingdate,
    endingdate,
    salestypeid,
    customerid,
    globalFilter,
    pagination,
    sorting,
    status
  ) => {
    setLoading(true);

    salestypeid = salestypeid > 0 ? salestypeid : 0;
    customerid = customerid > 0 ? customerid : 0;
    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/saleslist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&status=${status}&enddate=${endingdate}&salestypeid=${salestypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);

        const finalData = res.data.ResponseData.saleList.map((el) => {
          const mixdata = {
            ...el,
            items: res.data.ResponseData.itemList.filter(
              (itemName) => itemName.SaleId === el.ID
            ),
            ...el,
            Item : Number(el.Item),
            // Profit : Number(el.Profit)
          };
          return mixdata;
        });


        console.log(finalData, "finalData");
        setData(finalData);

        const result = res.data.ResponseData.saleList.reduce(
          (accumulator, currentItem) => {
            accumulator.Total += Number(currentItem.Total);
            accumulator.TotalQuantity += Number(currentItem.TotalQuantity);
            return accumulator;
          },
          { Total: 0, TotalQuantity: 0 }
        );

        console.log(result, "result");
        setTotalItemAmount(result.Total);
        setTotalItemQuantity(result.TotalQuantity);

        setTotalRows(res.data.ResponseData.saleList[0]?.TotalRecord);
        setRowCount(res.data.ResponseData.saleList[0]?.TotalRecord);

        setFilterTotalQuantity(
          parseFloat(res.data.ResponseData.saleList[0]?.SumQuantity).toFixed(2)
        );
        setFilterTotalAmount(
          parseFloat(res.data.ResponseData.saleList[0]?.SumTotal).toFixed(2)
        );

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  // const handleDeletePopup = (pID) => {
  //   const deleteRequestParam = {
  //     saleids: pID || selectedSalesCheckboxIds,
  //     locationid: location,
  //     loginuserid: loginuserid,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      saleids: data,
      locationid: location,
      loginuserid: loginuserid,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };
  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      // 1,
      // perPageSize,
      // searchtext,
      // sortingId,
      // sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status
    );
    // }
  }, [
    salesTypeID,
    customerID,
    status,
    quickBookOptions,
    globalFilter,
    pagination,
    sorting,
  ]);

  const statusoption = [
    { label: "All", value: 0 },
    { label: "Completed", value: 2 },
    { label: "Paid", value: 4 },
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 3 },
  ];

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  // const TotalItemQuantity = useMemo(
  //   () => data.reduce((acc, curr) => acc + Number(curr.TotalQuantity), 0),
  //   [],
  // )
  // const TotalItemAmount = useMemo(
  //   () => data.reduce((acc, curr) => acc + Number(curr.Total), 0),
  //   [],
  // )

  // console.log(
  //   totalItemAmount,
  //   totalItemQuantity,
  //   "TotalItemAmountTotalItemQuantity"
  // );
  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           <Link className="btn btn-primary btn-sm btn-custom-padding"
  //             to={`/manage-sales/${row.ID}`}
  //             style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //           >
  //             Edit
  //           </Link>

  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">

  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ID)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>&nbsp;Delete Sales
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 to={`/sales-receipt/${row.ID}`}
  //                 className="dropdown-item me-3"
  //               >
  //                 <i className="fa fa-file" aria-hidden="true"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //             {
  //               row.Receipt && (
  //                 <li>
  //                   <Link
  //                     // className="btn btn-sm btn-outline-primary btn-custom-padding"
  //                     className="dropdown-item me-3"
  //                     target="_blank"
  //                     to={row.Receipt}
  //                   >
  //                     <i className="fa fa-paperclip"></i>Attachment
  //                   </Link>
  //                 </li>
  //               )
  //             }
  //           </div>
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,

  //   },

  //   {
  //     // name: "Sale /\r\n Estimate /\r\n Return No",
  //     name: "Invoice No",
  //     selector: row => row["InvoiceNo"],
  //     sortable: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Date",
  //     //selector: "Saletime",
  //     selector: (row) => formatDate(row.Saletime),
  //     // selector: (row) => moment(row.Saletime).format('YYYY-MM-DD'),
  //     sortable: true,
  //     width: "110px",
  //   },
  //   {
  //     name: "Type",
  //     selector: row => row["SalesType"],
  //     sortable: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Status",
  //     selector: "StatusName",
  //     sortable: true,
  //     width: "100px"
  //   },
  //   {
  //     name: "Customer",
  //     cell: (row) => (
  //       <>
  //         <Link className="text-warning word-break-data" to={`/manage-customers/${row.Customerid}`}>
  //           {row.CustomerName}
  //         </Link>
  //       </>
  //     ),
  //     sortable: true,
  //     width: "150px",
  //   },

  //   {
  //     name: "Total",
  //     selector: row => row["Total"] > 0 ? parseFloat(row["Total"]).toFixed(2) : 0,
  //     right: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Amount Paid",
  //     selector: row => row["Paymentamount"] > 0 ? parseFloat(row["Paymentamount"]).toFixed(2) : 0,
  //     // sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   {
  //     name: "Wallet Applied",
  //     selector: row => row["CreditApplied"] > 0 ? parseFloat(row["CreditApplied"]).toFixed(2) : 0,
  //     // sortable: true,
  //     right: true,
  //     width: "150px",
  //   },

  //   {
  //     name: "Amount Due",
  //     // selector: row => row[field]"AmountDue",
  //     right: true,
  //     width: "150px",
  //     cell: (row) =>
  //       row.SaleTypeId == 1 ? row.AmountDue > 0 ? parseFloat(row.AmountDue).toFixed(2) : 0 : "-",
  //   },

  //   {
  //     name: "Location",
  //     selector: row => row["Location"],
  //     // width: "150px",
  //     // sortable: true,
  //   },
  //   {
  //     name: "Due Date",
  //     selector: (row) => row.DueDate != undefined && row.DueDate != "0000-00-00" ? formatDate(row.DueDate) : "",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Aging",
  //     // selector: row => row["Aging"],
  //     sortable: false,
  //     width: "70px",
  //     cell: (row) => (row.Aging > 0 ? row.Aging : ""),
  //   }

  // ];

  const columns = useMemo(() => [
    {
      //     //       {checkUserPermission(PERMISSION_EDIT) && (
      //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
      //     //           to={`/manage-customers/${row.Id}`}
      //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      //     //         >
      //     //           Edit
      //     //         </Link>
      //     //       )}
      //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
      //     //         <>
      //     //           <button
      //     //             type="button"
      //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
      //     //             data-bs-toggle="dropdown"
      //     //             aria-haspopup="true"
      //     //             aria-expanded="false"
      //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      //     //           >
      //     //           </button>
      //     //           <div className="dropdown-menu">
      //     //             {checkUserPermission(PERMISSION_EDIT) ? (
      //     //               <li>
      //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
      //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //             {checkUserPermission(PERMISSION_DELETE) ? (
      //     //               <li>
      //     //                 <Link
      //     //                   className="dropdown-item confirm-text"
      //     //                   to="#"
      //     //                   title="Delete"
      //     //                   data-bs-toggle="modal"
      //     //                   data-bs-target="#DeleteConfirmationModal"
      //     //                   onClick={() => handleDeletePopup(row.Id)}
      //     //                 >
      //     //                   <i
      //     //                     className="fa fa-trash"
      //     //                     data-bs-toggle="tooltip"
      //     //                     title="Delete"
      //     //                   ></i>
      //     //                   Delete
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //           </div>
      //     //         </>
      //     //       )}
      //     //     </div>
      //     //   ),
      //     //   ignoreRowClick: true,
      //     //   allowOverflow: true,
      //     //   button: true,
      //     //   //width: "7%",//"100px",
      //     //   minWidth: "90px",
      //     //   width: "90px",
      //     // },
      //     // {
      //     //   name: "Company Name",
      //     //   selector: "CompanyName",
      //     //   sortable: true,
      //     //   width: "170px",
      //     //   cell: (row) => (

      //     //     <>
      //     //       {checkUserPermission(PERMISSION_EDIT) ?
      //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //     //           {row.CompanyName}
      //     //         </Link>
      //     //         :
      //     //         row.CompanyName
      //     //       }
      //        header: "Company Name",
      //       accessorKey: "CompanyName",
      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     {
      //       header: "Name",
      //       accessorKey: "Name",
      //       Cell: ({ row }) => (
      //         <>
      //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //             {row.original.FirstName} {row.original.LastName}
      //           </Link>
      //         </>
      //       ),

      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     // {
      //     //   header: "DATE",
      //     //   accessorKey: "DATE",
      //     //   Cell: ({row})=> moment(row.original.DATE).format('YYYY-MM-DD')
      //     // },
      //     {
      //       header: "E-Mail",
      //       accessorKey: "Email",
      //       Cell: ({ row }) => (
      //         <>
      //           <p title={row.original.Email}>{row.original.Email}</p>
      //         </>
      //       ),
      // =======
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/sales-receipt/${row.original.ID}`}
          >
            {row.original.InvoiceNo}
          </Link>
        </>
      ),
    },
    {
      header: "Date",
      accessorKey: "Date",
      accessorFn: (row) => new Date(row.Saletime), // Convert to Date object for internal processing
      Cell: ({ row }) => moment(row.original.Saletime).format("DD-MM-YYYY"), // Format date for display
    },        
    {
      header: "Type",
      accessorKey: "SalesType",
    },
    {
      header: "Status",
      accessorKey: "StatusName",
    },
    {
      header: "Customer",
      accessorKey: "CustomerName",
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/manage-customers/${row.original.Customerid}`}
          >
            {row.original.CustomerName}
          </Link>
        </>
      ),
    },
    {
      header: "Item",
      accessorKey: "Item",
      filter: 'includes',
      filterFn: (row, columnId, filterValue) => {
        return row.original.items.some((el) => {
          return el.Name.toString().includes(filterValue.toString());
        });
      },
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{el.Name}</p>;
          })}
        </div>
      ),
    },
    {
      header: "Qty",
      accessorKey: "Qty",
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{parseFloat(el.Quantitypurchased)}</p>;
          })}
        </div>
      ),
      Footer: () => (
        <Box>
          Total Quantity: {parseFloat(filterTotalQuantity)}
        </Box>
      ),
      filter: 'includes',
      filterFn: (row, columnId, filterValue) => {
        return row.original.items.some((el) => {
          return el.Quantitypurchased.toString().includes(filterValue.toString());
        });
      },
    },
    {
      header: "Rate",
      accessorKey: "rate",
      Cell: ({ row }) => {
        const rates = row.original?.items.map((el) => parseFloat(el.Itemunitprice));
        return (
          <div>
            {rates.map((rate, index) => (
              <p key={index}>{rate.toFixed(2)}</p>
            ))}
          </div>
        );
      },
      accessorFn: (row) => {
        return row.items.map((el) => parseFloat(el.Itemunitprice));
      },
    },    
    {
      header: "Amount",
      accessorKey: "amount",
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{parseFloat(el.Total).toFixed(2)}</p>;
          })}
        </div>
      ),
      Footer: () => (
        <Box>Total Amount:{" " + parseFloat(filterTotalAmount).toFixed(2)}</Box>
      ),
      filterFn: (row, columnId, filterValue) => {
        return row.original.items.some((el) => {
          return parseFloat(el.Total) >= parseFloat(filterValue);
        });
      },
    },
    {
      header: "Total Quantity",
      accessorKey: "TotalQuantity",
      Cell: ({ row }) =>
        row.original.TotalQuantity > 0
          ? parseFloat(row.original.TotalQuantity).toFixed(2)
          : 0,
      Footer: () => (
        <Box>
          Total Quantity:{" " + parseFloat(filterTotalQuantity).toFixed(2)}
        </Box>
      ),
      filter: 'includes',
      filterFn: (row, columnId, filterValue) => {
        return row.original.items.some((el) => {
          return el.TotalQuantity?.toString().includes(filterValue?.toString());
        });
      },
    },
    {
      header: "Total Amount",
      accessorKey: "Total",
      Cell: ({ row }) =>
        row.original.Total > 0 ? parseFloat(row.original.Total).toFixed(2) : 0,
      // Footer: () => <Box>Total Amount:{" " + totalItemAmount}</Box>,
      Footer: () => (
        <Box>Total Amount:{" " + parseFloat(filterTotalAmount).toFixed(2)}</Box>
      ),
      filter: 'includes',
      filterFn: (row, columnId, filterValue) => {
        return row.original.items.some((el) => {
          return el.Total.toString().includes(filterValue.toString());
        });
      },
    },
    {
      header: "Amount Paid",
      accessorKey: "Paymentamount",
      Cell: ({ row }) =>
        row.original.Paymentamount > 0
          ? parseFloat(row.original.Paymentamount).toFixed(2)
          : 0,
    },
    {
      header: "Wallet Applied",
      accessorKey: "CreditApplied",
      Cell: ({ row }) =>
        row.original.CreditApplied > 0
          ? parseFloat(row.original.CreditApplied).toFixed(2)
          : 0,
    },
    {
      header: "Amount Due",
      accessorKey: "AmountDue",
      Cell: ({ row }) =>
        row.original.SaleTypeId == 1
          ? row.original.AmountDue > 0
            ? parseFloat(row.original.AmountDue).toFixed(2)
            : 0
          : "-",
    },
    {
      header: "Location",
      accessorKey: "Location",
      // Cell: ({ row }) => row.original.SaleTypeId == 1 ? row.original.AmountDue > 0 ? parseFloat(row.original.AmountDue).toFixed(2) : 0 : "-",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) =>
        row.original.DueDate != undefined &&
        row.original.DueDate != "0000-00-00"
          ? moment(row.original.DueDate).format("DD-MM-YYYY")
          : "",
    },
    {
      header: "Aging",
      accessorKey: "Aging",
      Cell: ({ row }) => (row.Aging > 0 ? row.Aging : ""),
    },
    // {
    //   header: "Profile",
    //   accessorKey: "Image",
    //   Cell: ({ row }) => (
    //     <>
    //       <a href={row.original.Image} target="_blank">
    //         <img
    //           src={row.original.Image}
    //           alt="Profile Image"
    //           style={{
    //             maxWidth: "30px",
    //             maxHeight: "70px",
    //             margin: "5px",
    //           }}
    //           onError={(e) => {
    //             e.target.onerror = null;
    //             e.target.src = Noimage;
    //           }}
    //         ></img>
    //       </a>
    //     </>
    //   ),
    // },
    // {
    //   header: "Created On",
    //   accessorKey: "CreatedDate",
    //   Cell: ({ row }) => formatDate(row.original.CreatedDate),
    // },
  ]);

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const downloadPDF = (rows, field) => {
  //   let newData = [];
  //   if (field === "selectedrow") {
  //     newData = rows.map((row) => row.original);
  //   } else if (field === "alldata") {
  //     newData = data;
  //   }
  //   console.log(newData, "newData");

  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 6px;">No</th>' +
  //       '<th style="padding: 6px; width: 3px">Invoice No</th>' +
  //       '<th style="padding: 6px;">Date</th>' +
  //       // '<th style="padding: 6px;">Sales Type</th>' +
  //       '<th style="padding: 6px;">Status</th>' +
  //       '<th style="padding: 6px;">Customer</th>' +
  //       '<th style="padding: 6px;">Item</th>' +
  //       '<th style="padding: 6px;">Qty</th>' +
  //       '<th style="padding: 6px;">Rate</th>' +
  //       // '<th style="padding: 6px;">Qty</th>' +
  //       '<th style="padding: 6px; width: 15px">Amount</th>' +
  //       '<th style="padding: 6px;">Due Amount</th>' +
  //       // '<th style="padding: 7px; text-align: right;">Location</th>' +
  //       // '<th style="padding: 6px; ">Due Date</th>' +
  //       // '<th style="padding: 7px; text-align: right;">Aging</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  //           <td style="font-size: 8px; padding: 6px;">
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1].InvoiceNo +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           moment(newData[index - 1].Saletime).format("DD-MM-YYYY") +
  //           "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px;">' +
  //           // newData[index - 1].SalesType +
  //           // "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1].StatusName +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1].CustomerName +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1]?.items?.map(
  //             (el) => "<div>" + el?.Name + "</div>"
  //           ) +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1]?.items?.map(
  //             (el) =>
  //               "<div>" + parseFloat(el?.Quantitypurchased).toFixed() + "</div>"
  //           ) +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1]?.items?.map(
  //             (el) => "<div>" + Number(el?.Itemunitprice).toFixed(2) + "</div>"
  //           ) +
  //           "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           newData[index - 1]?.items?.map(
  //             (el) => "<div>" + Number(el?.Total).toFixed(2) + "</div>"
  //           ) +
  //           "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px;">' +
  //           // Number(newData[index - 1].Total).toFixed(2) +
  //           // "</td>" +
  //           '<td style="font-size: 8px; padding: 6px;">' +
  //           parseFloat(newData[index - 1].Paymentamount).toFixed(2) +
  //           "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px;">' +
  //           // newData[index - 1].CreditApplied +
  //           // "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px; text-align: right;">' +
  //           // Number(newData[index - 1].AmountDue).toFixed(2) +
  //           // "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px; text-align: right;">' +
  //           // newData[index - 1].Location +
  //           // "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px;">' +
  //           // (newData[index - 1].DueDate != undefined &&
  //           // newData[index - 1].DueDate != "0000-00-00"
  //           //   ? moment(newData[index - 1].DueDate).format("DD-MM-YYYY")
  //           //   : "") +
  //           // // moment(newData[index - 1].DueDate).format("DD-MM-YYYY") +
  //           // "</td>" +
  //           // '<td style="font-size: 8px; padding: 6px;">' +
  //           // newData[index - 1].Aging +
  //           // "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content +=
  //       "<tfoot><tr style='margin-bottom: 5px'>" +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;"></td>' +
  //       '<td style="padding: 6px;">Qty: ' +
  //       // totalItemQuantity +
  //       filterTotalQuantity +
  //       "</td>" +
  //       '<td style="padding: 6px; text-align: right;"></td>' +
  //       '<td style="padding: 6px;">Total: ' +
  //       // totalItemAmount +
  //       filterTotalAmount +
  //       "</td>" +
  //       // '<td style="padding: 6px; text-align: right;">CreditApplied</td>' +
  //       // '<td style="padding: 6px; text-align: right;">AmountDue</td>' +
  //       // '<td style="padding: 6px; text-align: right;">Location</td>' +
  //       // '<td style="padding: 6px; text-align: right;"></td>' +
  //       // '<td style="padding: 6px; text-align: right;">Aging</td>' +
  //       "</tr></tfoot>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Sales.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

  // const generateTable = (data, startIndex, endIndex, rowsPerPage) => {
  //   let tableContent =
  //     "<table style='font-size: 8px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5'>";
  //   tableContent += "<thead><tr style='margin-bottom: 5px'>";

  //   // Add table headers
  //   tableContent += '<th style="padding: 6px;">No</th>';
  //   tableContent += '<th style="padding: 6px;">Invoice No</th>';
  //   tableContent += '<th style="padding: 6px;">Date</th>';
  //   tableContent += '<th style="padding: 6px;">Status</th>';
  //   tableContent += '<th style="padding: 6px;">Customer</th>';
  //   tableContent += '<th style="padding: 6px;">Item</th>';
  //   tableContent += '<th style="padding: 6px;">Qty</th>';
  //   tableContent += '<th style="padding: 6px;">Rate</th>';
  //   tableContent += '<th style="padding: 6px; width: 15px">Amount</th>';
  //   tableContent += '<th style="padding: 6px;">Due Amount</th>';
  //   // tableContent += '<th style="padding: 6px;">Qty</th>' ;
  //   // tableContent += '<th style="padding: 7px; text-align: right;">Location</th>' ;
  //   // tableContent += '<th style="padding: 6px; ">Due Date</th>' ;
  //   // tableContent += '<th style="padding: 7px; text-align: right;">Aging</th>' ;

  //   tableContent += "</tr></thead>";
  //   tableContent += "<tbody>";

  //   // Add table rows
  //   for (let index = startIndex; index <= endIndex; index++) {
  //     if (index <= data.length) {
  //       // Add row data
  //       tableContent += `<tr>
  //         <td style="font-size: 8px; padding: 6px;">${index}</td>
  //         <td style="font-size: 8px; padding: 6px;">${
  //           data[index - 1].InvoiceNo
  //         }</td>
  //         <td style="font-size: 8px; padding: 6px;">${moment(
  //           data[index - 1].Saletime
  //         ).format("DD-MM-YYYY")}</td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1].StatusName}
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1].CustomerName}
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1]?.items?.map(
  //             (el) =>"<div>" + el?.Name + "</div>"
  //           )}
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1]?.items?.map(
  //             (el) =>"<div>" +
  //               parseFloat(el?.Quantitypurchased).toFixed() + "</div>"
  //           )}
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1]?.items?.map(
  //             (el) =>"<div>" + Number(el?.Itemunitprice).toFixed(2) + "</div>"
  //           )} 
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${data[index - 1]?.items?.map(
  //             (el) =>"<div>" + Number(el?.Total).toFixed(2) + "</div>"
  //           )} 
  //           </td>
  //           <td style="font-size: 8px; padding: 6px;">
  //           ${parseFloat(data[index - 1].Paymentamount).toFixed(2)}
  //           </td> 
  //       </tr>`;
  //     }

  //     if (index % rowsPerPage === 0) {
  //       break;
  //     }
  //   }

  //   tableContent += "</tbody></table>";
  //   return tableContent;
  // };

  const generateFooter = (filterTotalQuantity, filterTotalAmount) => {
    return `<tfoot><tr style='margin-bottom: 5px'>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;">Qty: ${filterTotalQuantity}</td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;">Total: ${filterTotalAmount}</td>
      <td style="padding: 6px;"></td>
    </tr></tfoot></table></div>`;
  };

  const generatePageContent = (headerContent, tableContent, footerContent) => {
    return `${headerContent}${tableContent}${footerContent}`;
  };

  const generateHeader = () => {
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = "10px";
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    return clonedHeader.outerHTML;
  };

  // const downloadPDF = (rows, field, rowsPerPage = 12) => {
  //   let newData = [];
  //   if (field === "selectedrow") {
  //     newData = rows.map((row) => row.original);
  //   } else if (field === "alldata") {
  //     newData = data;
  //   }

  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = rowsPerPage;

  //   for (var i = 1; i <= Math.ceil(newData.length / rowsPerPage); i++) {
  //     const headerContent =
  //       i === 1 ? generateHeader() : generateHeader({ marginTop: "2.5rem" });
  //     const tableContent = generateTable(newData, startIndex, endIndex, rowsPerPage);
  //     const footerContent = generateFooter(filterTotalAmount, filterTotalQuantity);

  //     // Concatenate content for each page
  //     content += generatePageContent(
  //       headerContent,
  //       tableContent,
  //       footerContent
  //     );

  //     startIndex += rowsPerPage;
  //     endIndex += rowsPerPage;
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Sales.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

 
  
  const generateTable = (data, startIndex, endIndex, rowsPerPage) => {
    let tableContent =
      "<table style='font-size: 8px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5'>";
    tableContent += "<thead><tr style='margin-bottom: 5px'>";
  
    // Add table headers
    tableContent += '<th style="padding: 6px;">No</th>';
    tableContent += '<th style="padding: 6px;">Invoice No</th>';
    tableContent += '<th style="padding: 6px; width:60px;">Date</th>';
    tableContent += '<th style="padding: 6px;">Status</th>';
    tableContent += '<th style="padding: 6px;">Customer</th>';
    tableContent += '<th style="padding: 6px;">Item</th>';
    tableContent += '<th style="padding: 6px;">Qty</th>';
    tableContent += '<th style="padding: 6px;">Rate</th>';
    tableContent += '<th style="padding: 6px; width: 15px">Amount</th>';
    tableContent += '<th style="padding: 6px;">Due Amount</th>';
    // tableContent += '<th style="padding: 6px;">Qty</th>' ;
    // tableContent += '<th style="padding: 7px; text-align: right;">Location</th>' ;
    // tableContent += '<th style="padding: 6px; ">Due Date</th>' ;
    // tableContent += '<th style="padding: 7px; text-align: right;">Aging</th>' ;
  
    tableContent += "</tr></thead>";
    tableContent += "<tbody>";
  
    // Add table rows
    for (let index = startIndex; index <= endIndex; index++) {
      if (index <= data.length) {
        // Add row data
        tableContent += `<tr>
          <td style="font-size: 8px; padding: 6px;">${index}</td>
          <td style="font-size: 8px; padding: 6px;">${
            data[index - 1].InvoiceNo
          }</td>
          <td style="font-size: 8px; padding: 6px;">${moment(
            data[index - 1].Saletime
          ).format("DD-MM-YYYY")}</td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1].StatusName}
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1].CustomerName}
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1]?.items?.map(
              (el) =>"<div>" + el?.Name + "</div>"
            )}
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1]?.items?.map(
              (el) =>"<div>" +
                parseFloat(el?.Quantitypurchased).toFixed() + "</div>"
            )}
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1]?.items?.map(
              (el) =>"<div>" + Number(el?.Itemunitprice).toFixed(2) + "</div>"
            )} 
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${data[index - 1]?.items?.map(
              (el) =>"<div>" + Number(el?.Total).toFixed(2) + "</div>"
            )} 
            </td>
            <td style="font-size: 8px; padding: 6px;">
            ${parseFloat(data[index - 1].Paymentamount).toFixed(2)}
            </td> 
        </tr>`;
      }
  
    }
  
    tableContent += "</tbody>";
    // tableContent += generateBottomContent(); // Add bottom content
    return tableContent;
  };
  
  const downloadPDF = (rows, field, rowsPerPage = 16) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data;
    }
  
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");
  
    let content = "";
    let startIndex = 1;
    let endIndex = rowsPerPage;
    for (var i = 1; i <= Math.ceil(newData.length / rowsPerPage); i++) {
      content += "<div style='height: 840px; border: 1px solid white'>";
      const headerContent = generateHeader()
      const tableContent = generateTable(newData, startIndex, endIndex, rowsPerPage);
      const footerContent = generateFooter(filterTotalQuantity,filterTotalAmount);
  
      // Concatenate content for each page
      content += generatePageContent(
        headerContent,
        tableContent,
        footerContent
      );


      startIndex += rowsPerPage;
      endIndex += rowsPerPage;
    }


  
    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Sales.pdf");
        setLoading(false);
      },
    });
  };
  

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Sales_details_.xlsx`);
  };

  const handleChangeCustomer = (event) => {
    setCustomerValue(event);
    setCustomerID(event?.value);
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/salessummary?locationid=${localStorage.getItem("Location")}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        setSalesSummary(response.data.ResponseData[0]);
        console.log(response.data.ResponseData, "==> setSalesSummary");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const qtyAdjust =(InvoiceNo, closeMenu) =>{
    closeMenu();
      axios
      .post(`${config.salesconfigBaseUrl}/sales/qtyadjustforsalebyinvoice`, {
        id: InvoiceNo
      }, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        if(response.data.ResponseCode == "SUCCESS"){
          handleListData(
            startingDate,
            endingDate,
            salesTypeID,
            customerID,
            globalFilter,
            pagination,
            sorting,
            status
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Sales List</li>
              </ul>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {checkUserPermission(PERMISSION_ADD) ? (
              <div className="me-2">
                <Link className="btn btn-sm btn-primary" to={`/manage-sales`}>
                  <i className="fa fa-plus me-2 lg"></i> New Sales
                </Link>
              </div>
            ) : (
              ""
            )}

            {checkUserPermission(PERMISSION_RECEIVEPAYMENT) ? (
              <div className="me-2">
                <Link class="btn btn-sm btn-primary" to="/receive-payment">
                  <i className="fa fa-dollar me-2 lg"></i> Receive Payment
                </Link>
              </div>
            ) : (
              ""
            )}

            <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-dark dropdown-toggle me-1"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                More
              </button>

              {/* <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                  <i className="fas fa-ellipsis-h me-1 fs-6"></i>
                </button> */}
              <ul className="dropdown-menu">
                {checkUserPermission(PERMISSION_DELIVERIES) ? (
                  <li>
                    <Link
                      to="/deliveries"
                      title="Delivery Orders"
                      className="dropdown-item"
                    >
                      <i className="far fa-list-alt fs-6 me-1"></i> Delivery
                      Orders
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_BATCHSALES) ? (
                  <li>
                    <Link
                      to="/batch-sales"
                      title="Batch sale"
                      className="dropdown-item"
                    >
                      <i className="fas fa-shopping-bag fs-6 me-1"></i> Batch
                      sale
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                  <li>
                    <Link
                      className="dropdown-item"
                      data-bs-target="#LookupReceiptSaleModal"
                      data-bs-toggle="modal"
                    >
                      <i className="far fa-file-alt fs-6 me-1"></i> Lookup
                      Receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                  <li>
                    <Link
                      to="/sales-receipt"
                      title="Show last sale receipt"
                      className="dropdown-item"
                    >
                      <i className="fas fa-receipt fs-6 me-1"></i>Show last sale
                      receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {/* <li>
                    <Link to="/sales-customer-facing-display" title="Customer Facing Display" className="dropdown-item">
                      <i className="fas fa-desktop fs-6 me-1"></i> Customer Facing Display
                    </Link>
                  </li> */}
                {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                  <li>
                    <Link
                      to="/custom-field-sales-configuration"
                      title="Custom Field Configuration"
                      className="dropdown-item"
                    >
                      <i className="fas fa-wrench fs-6 me-1"></i> Custom Field
                      Configuration
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                  <li>
                    <Link
                      to="/sales-all-receipt"
                      title="Show all receipts for today"
                      className="dropdown-item"
                    >
                      <i className="far fa-file-alt fs-6 me-1"></i> Show all
                      receipts for today
                    </Link>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
            {/* <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                <i className="fa fa-cog"></i> &nbsp;
              </button> */}
            {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div> */}
            {/* </div> */}
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash-widget-custom">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash1} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary?.EstimateAmount} />
                    </span>
                  </h5>
                  <h6>{salesSummary.EstimateCount} Estimate</h6>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-2 col-sm-4 col-12">
              <div className="dash-widget dash1">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary.UnbilledActivityAmount} />
                    </span>
                  </h5>
                  <h6>{salesSummary.UnbilledActivityCount} Unbilled Activity </h6>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash-widget-custom dash2">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash3} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary.OverdueAmount} />
                    </span>
                  </h5>
                  <h6>{salesSummary.OverdueCount} Overdue</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash-widget-custom dash3">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash4} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary.OpenInvoicesAmount} />
                    </span>
                  </h5>
                  <h6>{salesSummary.OpenInvoicesCount} Open Invoices</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash-widget-custom dash2">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                    {/* <img src={Dash4} alt="img" /> */}
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary.LastPaidCountAmount} />
                      {/* {salesSummary.LastPaidCountAmount} */}
                    </span>
                  </h5>
                  <h6>{salesSummary.LastPaidCount} Paid Last 30 Days</h6>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 ">
              <div className="d-flex flex-wrap">
                <div className="col-md-2 mt-1">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={selectStyles}
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="ml-2 col-md-2">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="ml-2 col-md-2">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                  </>
                )}
                {quickBookOptions?.value == 2 && (
                  <div className="ml-2 col-md-1">
                    <button
                      className="btn btn-dark btn-sm mt-4 w-100"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      Search
                    </button>
                  </div>
                )}
                <div className="ml-2 col-md-2">
                  Sales Type:
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    className="custom-search-select mt-1"
                  />
                </div>
                <div
                  className={
                    quickBookOptions?.value == 2
                      ? "ml-2 mb-2 col-md-2 "
                      : "ml-2 mb-2 col-md-4 "
                  }
                >
                  Customer:
                  <Select
                    defaultValue={customerValue}
                    onChange={(event) => {
                      handleChangeCustomer(event);
                    }}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    className="custom-search-select mt-1"
                  />
                </div>

                <div
                  className={
                    quickBookOptions?.value == 2
                      ? " mb-2 col-md-2 "
                      : "ml-2 mb-2 col-md-2 "
                  }
                >
                  Status:
                  <Select
                    defaultValue={status}
                    onChange={(e) => {
                      setStatus(e?.value);
                    }}
                    options={statusoption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body custom-table-css">
              <div className="table-responsive">
                {/* <DataTable
                  title="Sales List"
                  // columns={columns}
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  dense
                  paginationPerPage={perPageSize}
                /> */}

                {/* Receipt */}
                <div className="container" style={{ display: "none" }}>
                  <div className="col-md-12 text-center" id="header">
                    <h2>Jarkan</h2>
                    <p className="fw-bold">Sales Report</p>
                    <div className="row">
                      {(customStartingDate || customEndingDate) && (
                        <>
                          <p>
                            Date: {moment(customStartingDate).format("DD-MM-YYYY") } to {moment(customEndingDate).format("DD-MM-YYYY") }
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <hr />
                </div>

                <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  enableColumnFilters
                  // rowCount={totalRows}
                  renderRowActionMenuItems={({ row, closeMenu }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/manage-sales/${row.original.ID}`)
                        }
                      >
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(
                            row.original.ID,
                            "",
                            "singlerowdelete"
                          )
                        }
                      >
                        Delete
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission(PERMISSION_RECEIPT) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        onClick={() =>
                          navigate(`/sales-receipt/${row.original.ID}`)
                        }
                      >
                        Receipt
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    row.original.Receipt && (
                      <NavLink to={`${row.original.Receipt}`}>
                        <MenuItem
                          className="confirm-text"
                          to="#"
                          target="_blank"
                        >
                          Attachment
                        </MenuItem>
                      </NavLink>
                    ),
                    row.original.TotalQuantity == 0 ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        onClick={() => qtyAdjust(row.original.InvoiceNo, closeMenu)}
                      >
                        Qty Adjust
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "alldata")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                      {checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}
                      {/* <Button
                        size="small"
                        onClick={() =>
                          setPagination({ ...pagination, pageSize: totalRows })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  rowVirtualizerProps={{
                    overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                    estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
              {/* <div>
                <div className="pull-right">
                  <strong className="mb-0">
                    Total Quantity: {parseFloat(filterTotalQuantity).toFixed(2)}
                  </strong>
                  <br />
                  <strong className="mb-0">
                    Total Amount: {parseFloat(filterTotalAmount).toFixed(2)}{" "}
                  </strong>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      <LookupReceiptSaleModal />
    </>
  );
};

export default Sales;
